import { Spinner } from "./styles.styled";
import { FC } from "react";

interface IProps {
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  border?: string;
}

const SpinnerLoader: FC<IProps> = ({
  width = 50,
  height = 50,
  color = "#f3f3f3",
  className,
  border = 5,
}) => {
  return (
    <Spinner
      className={"spinnerLoader " + className}
      width={width}
      height={height}
      color={color}
      border={border}
    />
  );
};

export default SpinnerLoader;
